import type { AppConfig } from '#/config/types/AppConfig';
import type { SearchFiltersById } from '#/modules/search/types/SearchFiltersById';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchAlgoliaIndex } from './searchAlgoliaIndex';
import { searchAlgoliaVolopsIndex } from './searchAlgoliaVolopsIndex';

export const searchAlgoliaIndexSwitch = ({
  filtersById,
  sort,
  appConfig,
}: {
  filtersById: SearchFiltersById;
  sort: SearchSortType;
  appConfig: AppConfig;
}) => {
  // oxlint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (filtersById.type) {
    case 'VOLOP':
      return searchAlgoliaVolopsIndex({ sort, appConfig });
    case 'EVENT':
      return searchAlgoliaVolopsIndex({ sort, appConfig });
    default:
      return searchAlgoliaIndex({ sort, appConfig });
  }
};
